import styled from 'styled-components'
import { fontWeight, lineHeight, variant } from 'styled-system'

import Text from './Text'

export const defaultValues = {
  fontFamily: 'Proxima',
  fontSize: 2,
  lineHeight: '24px' /* 150% */,
  letterSpacing: '0.352px',
  fontWeight: 400
}

const P = styled(Text)(
  variant({
    variants: {
      default: {
        ...defaultValues
      },
      bold: {
        ...defaultValues,
        fontWeight: 'semibold'
      }
    }
  })
)

P.defaultProps = {
  as: 'p',
  variant: 'default'
}

export default P
